import { cn } from '@shared/utils';

interface MobileRowProps {
  accountTab?: boolean;
  data: { value: string }[];
  onClick: () => void;
}

export const MobileRow = (props: MobileRowProps) => {
  return (
    <div
      className={cn(
        'flex h-[65px] items-center justify-between bg-[#efefef] px-[15px] py-[10px] pl-[22px]',
        'last:rounded-b-[4px]',
        'even:bg-[#e6e6e6]',
        '[&+&]:border-t [&+&]:border-[#d5d5d5]',
      )}
      onClick={props.onClick}
    >
      <div className='flex flex-col items-start justify-between'>
        <div className='mb-1 text-sm font-semibold text-[#191919]'>{props.data[0].value}</div>
        <div className='text-sm font-medium text-[#343434]'>{props.accountTab ? props.data[1].value : props.data[2].value}</div>
      </div>

      <div className='flex items-center justify-end whitespace-nowrap'>
        <div className='mr-5 text-sm font-medium whitespace-nowrap text-[#343434]'>{props.accountTab && props.data[5].value}</div>
        <div className='flex items-center justify-center'>
          <svg width='7' height='12' viewBox='0 0 7 12' xmlns='http://www.w3.org/2000/svg'>
            <path
              d='M6.653 6.59l-5.095 5.095c-.227.227-.594.227-.821 0l-.41-.41c-.227-.227-.227-.594 0-.821l4.274-4.275-4.274-4.274c-.227-.227-.227-.595 0-.821l.41-.41c.227-.227.594-.227.821 0l5.095 5.096c.227.227.227.594 0 .82z'
              fill='#929292'
            />
          </svg>
        </div>
      </div>
    </div>
  );
};
